import { render } from "./NuovaVendita.vue?vue&type=template&id=cf02ebe4&scoped=true"
import script from "./NuovaVendita.vue?vue&type=script&lang=js"
export * from "./NuovaVendita.vue?vue&type=script&lang=js"

import "./NuovaVendita.vue?vue&type=style&index=0&id=cf02ebe4&lang=css"
import "./NuovaVendita.vue?vue&type=style&index=1&id=cf02ebe4&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf02ebe4"]])

export default __exports__